<div class="d-flex justify-content-center {{customClass}} overflow-hidden" [ngClass]="{'full-height': allowFullHeight}">
    <div class="row">
        <div class="mx-auto my-auto">
            <div class="text-center">
                <img src="/assets/images/custom/loader.gif" width="70px" role="status" />
                <h5 class="mt-2">{{loadingMessage}}</h5>
            </div>
        </div>
    </div>
</div>